const PLAN_NAMES: Record<string, string> = {
  lemon: "Free",
  mandarin: "Mini",
  pomelo: "Premium",
};

export function getSubscriptionPlanName(plan: string): string {
  return PLAN_NAMES[plan.toLowerCase()] ?? plan;
}
